import { Skeleton } from '@/components/Skeleton';

import i18n from '@/i18n';
import { Container } from '@mui/joy';
import { GenericList } from '@/components/GenericList';
import { ArtistCard } from '@/components/ArtistCard';

export function PeoplePage() {
  return (
    <Container>
      <GenericList
        path={`/people`}
        type="person"
        avatar={true}
        canAdd={true}
        addLabel={i18n.t('add-person')}
        filterPlaceholder={i18n.t('filter-people')}
        NodeCardComponent={ArtistCard}
        heading={i18n.t('people')}
        addUrl={`../person/add`}
        baseUrl={`../person`}
      />
    </Container>
  )
}

export function PeopleSkeleton() {
  return (
    <Container>
      <div style={{ display: 'flex', flexDirection: 'row', gap: 10}}>
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
      </div>
    </Container>
  )
}

export default PeoplePage